import { BAOCustomElement } from '@bao/custom-element'

const PhotoSwipe = window.PhotoSwipe
const PhotoSwipeLightbox = window.PhotoSwipeLightbox

export class ProductPhotoSwipe extends BAOCustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.link?.exists) return

    this.photoSwipeInstance = new PhotoSwipeLightbox({
      loop: false,
      showAnimationDuration: 300,
      scaleMode: 'zoom',

      gallery: this,
      children: this.els.link.selector,
      bgOpacity: 1,
      arrowPrev: true,
      arrowNext: true,
      zoom: false,
      close: false,
      counter: false,
      preloadFirstSlide: true,
      closeOnVerticalDrag: true,
      tapAction: 'zoom',

      pswpModule: () => {
        return PhotoSwipe
      },
    })

    this.setupPhotoSwipeListeners()
    this.photoSwipeInstance.init()
  }

  setupListeners () {
    super.setupListeners()
  }

  setupPhotoSwipeListeners () {
    this.photoSwipeInstance.on('uiRegister', () => {
      this.addCloseButton()
      this.addThumbnails()
    })
  }

  addCloseButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-close',
      className: 'pswp-Action_Close',
      ariaLabel: 'Close',
      order: 2,
      isButton: true,
      html: this.closeSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.close()
      },
    })
  }

  addThumbnails () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'dots',
      className: 'pswp-Action_Thumbnails',
      appendTo: 'wrapper',
      onInit: (element, pswp) => {
        const dotEls = []
        let thumbEl
        let dotEl
        let previousIndex = -1

        for (let i = 0; i < pswp.getNumItems(); i++) {
          dotEl = document.createElement('button')
          dotEl.type = 'button'
          dotEl.className = 'pswp-Action_Thumbnail'
          dotEl.onclick = (event) => {
            pswp.goTo(dotEls.indexOf(event.target))
          }

          thumbEl = document.createElement('img')
          thumbEl.className = 'pswp-Action_ThumbnailImage'
          thumbEl.src = this.els.link.elements[i].dataset.thumbImage

          dotEl.appendChild(thumbEl)
          element.appendChild(dotEl)

          dotEls.push(dotEl)
        }

        pswp.on('change', () => {
          if (previousIndex >= 0) {
            dotEls[previousIndex].setAttribute('aria-current', 'false')
          }
          dotEls[pswp.currIndex].setAttribute('aria-current', 'true')
          previousIndex = pswp.currIndex
        })
      },
    })
  }

  get closeSvg () {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" aria-hidden="true">
        <path stroke="currentColor" stroke-width="1.2" d="m5.75 14.244 8.485-8.485M5.758 5.759l8.485 8.485"/>
      </svg>
    `
  }
}

if (!customElements.get('product-photoswipe')) {
  customElements.define('product-photoswipe', ProductPhotoSwipe)
}
